(() => {
  const namespace = window.KGGroutCalculator;

  if (!namespace) {
    return;
  }

  const calculators = document.querySelectorAll(
    '[data-grout-calculator]'
  );

  const initializedContexts =
    (window.KGGroutCalculatorContexts =
      window.KGGroutCalculatorContexts || {});

  const isClosedUpsellsDrawerCalculator = (ctx) => {
    const calculator = ctx?.calculator;
    if (!calculator) return false;
    if (calculator.dataset.calculatorOwner !== 'upsells') return false;

    const drawer = calculator.closest('.customize-drawer-upsells');
    return Boolean(drawer) && !drawer.classList.contains('open');
  };

  const recalculateAll = (ctx) => {
    if (isClosedUpsellsDrawerCalculator(ctx)) {
      return;
    }

    namespace.calculateGrout(ctx);
    namespace.calculateSilicone(ctx);
    namespace.calculateFastmassa(ctx);
    namespace.calculatePrimer(ctx);
    namespace.calculatePassbitar(ctx);
    namespace.calculatePiedestal(ctx);
    namespace.calculateUnderlay(ctx);
    namespace.calculateLeveling(ctx);
    namespace.calculateSpacers(ctx);
  };

  const scheduleRecalculate = (ctx) => {
    if (!ctx) return;
    if (isClosedUpsellsDrawerCalculator(ctx)) return;
    if (ctx.__kgRecalculateQueued) return;

    ctx.__kgRecalculateQueued = true;

    window.requestAnimationFrame(() => {
      ctx.__kgRecalculateQueued = false;
      recalculateAll(ctx);
    });
  };

  const recalculateDrawerCalculatorFromQty = (input) => {
    if (typeof window.KGRecalculateUpsellDrawerCalculator === 'function') {
      window.KGRecalculateUpsellDrawerCalculator(input);
      return;
    }

    const drawerContent = input?.closest(
      '.customize-drawer-content-upsells'
    );
    const calculator = drawerContent?.querySelector(
      '[data-grout-calculator][data-calculator-owner="upsells"]'
    );
    const ctx = calculator?.__kgCalculatorContext;

    if (ctx) {
      recalculateAll(ctx);
    }
  };

  const initCalculator = (calculator) => {
    if (!calculator || calculator.dataset.initialized === 'true') {
      return calculator?.__kgCalculatorContext || null;
    }

    calculator.dataset.initialized = 'true';

    const ctx = namespace.createContext(calculator);

    if (!ctx) {
      return null;
    }

    calculator.__kgCalculatorContext = ctx;
    initializedContexts[ctx.data.calculatorScope || 'bundle'] = ctx;

    namespace.mountFogmassaDrawerLayout(ctx);
    namespace.mountLevelingDrawerLayout(ctx);
    namespace.mountUnderlayDrawerLayout(ctx);

    const {
      externalAreaInput,
      decreaseButton,
      increaseButton,
      addButton,
      addSiliconeButton,
      addFastmassaButton,
      addPrimerButton,
      addPassbitarButton,
      passbitarProductButtons,
      addPiedestalButton,
      addUnderlayButton,
      siliconeScenarioSelect,
      siliconeManualMetersInput,
      siliconeJointWidthInput,
      siliconeJointDepthInput,
      siliconeShapeSelect,
      addLevelingButton,
      addLevelingHatButton,
      addLevelingGunButton,
      levelingSizeSelect,
      spacerSizeSelect,
      addSpacerButton,
      bundleCheckbox,
      quickCardElement,
      bundleCartMessage,
      drawerAreaDecreaseButton,
      drawerAreaIncreaseButton,
      productForm,
      productSubmitButton
    } = ctx.elements;

    if (externalAreaInput) {
      ['input', 'change', 'blur'].forEach((eventName) => {
        externalAreaInput.addEventListener(eventName, () =>
          scheduleRecalculate(ctx)
        );
      });
    }

    const calculateAfterButtonClick = () => {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          scheduleRecalculate(ctx);
        });
      });
    };

    if (decreaseButton) {
      decreaseButton.addEventListener(
        'click',
        calculateAfterButtonClick
      );
    }

    if (increaseButton) {
      increaseButton.addEventListener(
        'click',
        calculateAfterButtonClick
      );
    }

    if (drawerAreaDecreaseButton) {
      drawerAreaDecreaseButton.addEventListener('click', () =>
        namespace.adjustDrawerArea(ctx, -1)
      );
    }

    if (drawerAreaIncreaseButton) {
      drawerAreaIncreaseButton.addEventListener('click', () =>
        namespace.adjustDrawerArea(ctx, 1)
      );
    }

    if (addButton) {
      addButton.addEventListener('click', () =>
        namespace.addRecommendedGroutToCart(ctx)
      );
    }

    [
      siliconeScenarioSelect,
      siliconeManualMetersInput,
      siliconeJointWidthInput,
      siliconeJointDepthInput,
      siliconeShapeSelect
    ].forEach((element) => {
      if (!element) {
        return;
      }

      element.addEventListener('input', () =>
        namespace.calculateSilicone(ctx)
      );
      element.addEventListener('change', () =>
        namespace.calculateSilicone(ctx)
      );
    });

    if (addSiliconeButton) {
      addSiliconeButton.addEventListener('click', () =>
        namespace.addRecommendedSiliconeToCart(ctx)
      );
    }

    if (addFastmassaButton) {
      addFastmassaButton.addEventListener('click', () =>
        namespace.addRecommendedFastmassaToCart(ctx)
      );
    }

    if (addPrimerButton) {
      addPrimerButton.addEventListener('click', () =>
        namespace.addRecommendedPrimerToCart(ctx)
      );
    }

    if (addPassbitarButton) {
      addPassbitarButton.addEventListener('click', () =>
        namespace.addRecommendedPassbitarToCart(ctx)
      );
    }

    passbitarProductButtons?.forEach((button) => {
      button.addEventListener('click', () => {
        const selectedVariantId = Number.parseInt(
          button.dataset.passbitarVariantId,
          10
        );

        ctx.state.selectedPassbitarProduct =
          ctx.data.passbitarProducts.find(
            (product) => product.variantId === selectedVariantId
          ) || ctx.state.selectedPassbitarProduct;

        namespace.syncPassbitarProductUI(ctx);
        namespace.calculatePassbitar(ctx);
      });
    });

    if (addPiedestalButton) {
      addPiedestalButton.addEventListener('click', () =>
        namespace.addRecommendedPiedestalToCart(ctx)
      );
    }

    if (addUnderlayButton) {
      addUnderlayButton.addEventListener('click', () =>
        namespace.addRecommendedUnderlayToCart(ctx)
      );
    }

    if (levelingSizeSelect) {
      levelingSizeSelect.addEventListener('change', () => {
        ctx.state.selectedLevelingProduct =
          namespace.findClosestProductBySize(
            ctx.data.levelingProducts,
            levelingSizeSelect.value
          ) || ctx.state.selectedLevelingProduct;

        namespace.syncLevelingProductUI(ctx);
        namespace.calculateLeveling(ctx);
      });
    }

    ctx.elements.levelingSizeButtons?.forEach((button) => {
      button.addEventListener('click', () => {
        const preferredSize =
          button.dataset.levelingSizeValue || '';

        ctx.state.selectedLevelingProduct =
          namespace.findClosestProductBySize(
            ctx.data.levelingProducts,
            preferredSize
          ) || ctx.state.selectedLevelingProduct;

        namespace.syncLevelingProductUI(ctx);
        namespace.calculateLeveling(ctx);
      });
    });

    if (addLevelingButton) {
      addLevelingButton.addEventListener('click', () =>
        namespace.addRecommendedLevelingToCart(ctx)
      );
    }

    if (addLevelingHatButton) {
      addLevelingHatButton.addEventListener('click', () =>
        namespace.addRecommendedLevelingHatToCart(ctx)
      );
    }

    if (addLevelingGunButton) {
      addLevelingGunButton.addEventListener('click', () =>
        namespace.addRecommendedLevelingGunToCart(ctx)
      );
    }

    if (spacerSizeSelect) {
      spacerSizeSelect.addEventListener('change', () => {
        ctx.state.selectedSpacerProduct =
          namespace.findClosestProductBySize(
            ctx.data.spacerProducts,
            spacerSizeSelect.value
          ) || ctx.state.selectedSpacerProduct;

        namespace.syncSpacerProductUI(ctx);
        namespace.calculateSpacers(ctx);
      });
    }

    if (addSpacerButton) {
      addSpacerButton.addEventListener('click', () =>
        namespace.addRecommendedSpacerToCart(ctx)
      );
    }

    if (bundleCheckbox) {
      bundleCheckbox.addEventListener('change', () => {
        if (quickCardElement) {
          quickCardElement.classList.toggle(
            'grout-calculator__quick--selected',
            bundleCheckbox.checked
          );
        }

        if (bundleCartMessage && !bundleCheckbox.checked) {
          bundleCartMessage.textContent = '';
        }
      });
    }

    if (productForm) {
      productForm.addEventListener('submit', () =>
        namespace.queueBundleWithMainProduct(ctx)
      );
    }

    if (productSubmitButton) {
      productSubmitButton.addEventListener('click', () =>
        namespace.queueBundleWithMainProduct(ctx)
      );
    }

    document.addEventListener(
      'click',
      (event) => {
        const addToCartTrigger = event.target.closest(
          '#add-to-cart-main'
        );

        if (!addToCartTrigger) {
          return;
        }

        namespace.queueBundleWithMainProduct(ctx);
      },
      true
    );

    scheduleRecalculate(ctx);
    return ctx;
  };

  window.KGEnsureCalculatorInitialized = initCalculator;

  document.addEventListener('input', (event) => {
    const qtyInput = event.target.closest('.qty-input-upsells');
    if (!qtyInput) return;
    recalculateDrawerCalculatorFromQty(qtyInput);
  });

  document.addEventListener('change', (event) => {
    const qtyInput = event.target.closest('.qty-input-upsells');
    if (!qtyInput) return;
    recalculateDrawerCalculatorFromQty(qtyInput);
  });

  calculators.forEach((calculator) => {
    const isUpsellsCalculator =
      calculator.dataset.calculatorOwner === 'upsells';
    const inUpsellsDrawer = calculator.closest(
      '.customize-drawer-upsells'
    );

    if (isUpsellsCalculator && inUpsellsDrawer) {
      return;
    }

    initCalculator(calculator);
  });
})();
